import React from "react";
import {observer} from "mobx-react-lite";
import {useSitStores} from "../../../../stores";
import dayjs from "dayjs";

export const InitiativeSuccessStepFrom: React.FC = observer(() => {
    const {initiativeInstanceStore: s} = useSitStores();
    const dis = s.disabled;

    return (
        <div className="sit-miles">
            {s.ss_c.map((ssc, index) => (
                <div className="sit-mile" key={index}>
                    <input type="checkbox" checked={ssc.instance.achieved} disabled={dis}
                           onChange={() => ssc.toggleAchieved()}/>
                    <input className="sit-mile-text" placeholder="Milestone title" value={ssc.instance.title} disabled={dis}
                           onChange={e => ssc.title = e.target.value}/>
                    <input type="date" disabled={dis} value={ssc.dueDate.format('YYYY-MM-DD')}
                           onChange={e => { if (e.target.value) ssc.dueDate = dayjs(e.target.value); }}/>
                    <button type="button" className="sit-rm-btn" disabled={dis}
                            onClick={() => s.removeSuccessStep(index)} aria-label="Remove">✕
                    </button>
                </div>
            ))}
            <button type="button" className="sit-add-line" disabled={dis} onClick={() => s.addSuccessStep()}>
                + Add milestone
            </button>
        </div>
    );
});
